import React, { useState } from 'react';
import { Form, Button, Row, Col, Input, DatePicker, Select, Space } from 'antd';
import { DownOutlined, UpOutlined } from '@ant-design/icons';
// import Selectcategory from '@/components/edit-activity-plan/select-category.js'
import { ACTIVITY_LEVELS, ACTIVITY_STATUS } from '@/constants/index';
import ComponentLog from '@/components/component-log';
import SelectPlancodeLevel from '@/form-component/select-plancode-level';
import { formateTimeStampToSecondPrecision } from '@/common/utils';
import { ACTIVITY_TYPES } from '@/constants/activity-type';
import { prefixCls } from '@/constants';
import '../list.less';
import './index.less';

const { RangePicker } = DatePicker;
const { Option } = Select;

const Demo = ({ onChange = () => {}, addCreator = false }) => {
  const [form] = Form.useForm();
  const onFinish = (values) => {
    const { activityTime, organization, ..._values } = values;
    let startTime, endTime;

    if (activityTime) {
      startTime = activityTime[0].startOf('day').valueOf();
      endTime = formateTimeStampToSecondPrecision(activityTime[1].endOf('day').valueOf());
    }

    onChange({
      startTime,
      endTime,
      organization,
      ..._values,
    });
  };

  // 设置查询表单是否展开的参数   展开：true， 收起：false
  const [isFormStretch, setIsFormStretch] = useState(false);

  // 查询/重置 组件
  const QueryResetFrom = (props) => {
    const { isFormStretch } = props;
    return (
      <div key="btn-form" className="btn-form">
        <Space size={8}>
          <ComponentLog>
            <Button clstag="hdgl_1603707393179|5" shape="round" type="primary" htmlType="submit">
              查询
            </Button>
          </ComponentLog>
          <ComponentLog>
            <Button clstag="hdgl_1603707393179|6" shape="round" onClick={() => form.resetFields()} type="submit">
              重置
            </Button>
          </ComponentLog>
          <span className="form-isSretch" onClick={() => setIsFormStretch(!isFormStretch)}>
            {isFormStretch ? (
              <>
                收起
                <UpOutlined />
              </>
            ) : (
              <>
                展开
                <DownOutlined />
              </>
            )}
          </span>
        </Space>
      </div>
    );
  };

  const formItemArr = [
    <Form.Item name="planCode" label="活动编号" colon={false}>
      <Input maxLength={50} placeholder="请输入活动编号" />
    </Form.Item>,
    <Form.Item name="activityName" label="活动名称" colon={false}>
      <Input maxLength={50} placeholder="请输入活动名称" />
    </Form.Item>,
    <Form.Item
      name="activityTime"
      label="活动时间"
      rules={[{ type: 'array', message: '活动时间不能为空' }]}
      colon={false}
    >
      <RangePicker
        style={{ width: '100%' }}
        className={prefixCls + '-picker-full-size'}
        placeholder={['开始日期', '结束日期']}
      />
    </Form.Item>,
    <Form.Item name="level" label="活动级别" colon={false}>
      <SelectPlancodeLevel mode="multiple" version={1} className="all-about-me-signed-activity-select" />
    </Form.Item>,
    isFormStretch ? (
      <Form.Item name="status" label="活动状态" colon={false}>
        <Select placeholder="请选择状态" allowClear className="all-about-me-signed-activity-select">
          {ACTIVITY_STATUS.map((item) => (
            <Option key={item.val} value={item.val}>
              {item.title}
            </Option>
          ))}
        </Select>
      </Form.Item>
    ) : null,
    isFormStretch ? (
      <Form.Item label="活动类型" name="activityType" colon={false}>
        <Select placeholder="请选择活动类型" allowClear className="all-about-me-signed-activity-select">
          <Option>全部</Option>
          {ACTIVITY_TYPES.map((item) => (
            <Option key={item.val} value={item.val}>
              {item.title}
            </Option>
          ))}
        </Select>
      </Form.Item>
    ) : null,
    isFormStretch && addCreator ? (
      <Form.Item name="creator" label="活动创建人" colon={false}>
        <Input placeholder="请输入活动创建人" />
      </Form.Item>
    ) : null,
    <QueryResetFrom isFormStretch={isFormStretch} />,
  ];

  const filteredFormItemArr = formItemArr.filter((item) => item !== null);

  const ChildForm = () => {
    return (
      <div className="TY__main-new-form">
        {filteredFormItemArr.map((ele, index) => {
          return <div key={ele?.key || index}>{ele}</div>;
        })}
      </div>
    );
  };

  return (
    <Form form={form} onFinish={onFinish} className="activity-manage-form">
      <ChildForm />
    </Form>
  );
};

export default Demo;
